import React from 'react';
import { useTheme } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import Box from '@material-ui/core/Box';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';

const items = [
  {
    title: 'Perfil ejecutivo',
    feedback:
      'Nuestra audiencia está compuesta por tomadores de decisiones, líderes empresariales y profesionales del sector.',
  },
  {
    title: 'Calidad audiovisual',
    feedback:
      'En un sector de ingeniería, la precisión y la calidad de la imagen importan. Su marca se verá al nivel de las grandes transnacionales.',
  },
  {
    title: 'Conexión estratégica',
    feedback:
      'No solo grabamos; conectamos su mensaje con el ecosistema de negocios de Venezuela para convertir presencia en posicionamiento.',
  },
];

const PorQueTNO = () => {
  const theme = useTheme();

  return (
    <Box>
      <Box marginBottom={4}>
        <Typography variant="h4" fontWeight={700} align="left" gutterBottom>
          ¿Por qué TNO Network
          <br />
          para su marca en la Expo Petróleo?
        </Typography>
      </Box>
      <Grid container spacing={3}>
        {items.map((item, i) => (
          <Grid item xs={12} md={4} key={i}>
            <Box
              width="100%"
              height="100%"
              data-aos="fade-up"
              component={Card}
              display="flex"
              flexDirection="column"
              sx={{ borderTop: 4, borderColor: theme.palette.primary.main }}
            >
              <CardContent sx={{ flex: 1 }}>
                <Typography variant="h6" fontWeight={700} gutterBottom color="primary">
                  {item.title}
                </Typography>
                <Typography color="textSecondary">{item.feedback}</Typography>
              </CardContent>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default PorQueTNO;
